module.exports = __webpack_public_path__ + "static/media/travel_marker.e4f5f7de.png";